import { useNavigate } from "react-router-dom";
import "../../styles/NeedLegalAssistance.css";
import { FaCheck, FaSearch, FaUser } from "react-icons/fa";

export default function NeedLegalAssistance() {
  const navigate = useNavigate();

  return (
    <section className="nla-section">
      <div className="nla-container">

        {/* LEFT */}
        <div className="nla-left">
          <div className="nla-content">

            <span className="nla-badge">
              <FaCheck className="nla-badge-icon" />
              Professional Legal Support
            </span>

            <h2 className="nla-title">
              Need Professional <br />
              <span className="nla-highlight">Legal Assistance?</span>
            </h2>

            <p className="nla-description">
              Connect with our network of verified legal professionals. Get expert advice,
              document review, and case assessment within 24 hours.
            </p>

            <div className="nla-features">
              <div className="nla-feature-item">
                <div className="nla-feature-icon"><FaCheck /></div>
                <span>24/7 Legal Consultation</span>
              </div>

              <div className="nla-feature-item">
                <div className="nla-feature-icon"><FaCheck /></div>
                <span>Verified Solicitors</span>
              </div>

              <div className="nla-feature-item">
                <div className="nla-feature-icon"><FaCheck /></div>
                <span>Confidential & Secure</span>
              </div>
            </div>

            <div className="nla-buttons">
              <button
                className="nla-primary-btn"
                onClick={() => navigate("/search")}
              >
                <FaSearch className="nla-btn-icon" />
                Find a Solicitor Now
              </button>

              <button
                className="nla-secondary-btn"
                onClick={() => navigate("/login")}
              >
                <FaUser className="nla-btn-icon" />
                I'm a Solicitor
              </button>
            </div>

            <div className="nla-trust">
              <span className="nla-trust-text">
                Trusted by 500+ clients nationwide
              </span>
              <span className="nla-rating-text">
                <span style={{ color: "#d6b87c" }}>★★★★★</span> 4.9/5 Rating
              </span>
            </div>

          </div>
        </div>

        {/* RIGHT – fixed image */}
        <div className="nla-right">
          <img src="/Home/cta.png" alt="Legal support" />
        </div>

      </div>
    </section>
  );
}
